import PropTypes from 'prop-types';
import "../../input/Input.scss";
import { Iconify } from '../../../../ui';

const Label = (props) => {
    const { fieldSetting } = props;
    const isLabelIconVisible = fieldSetting?.labelConfig?.isLabelIconVisible && !!fieldSetting?.labelConfig?.icon;

    return (
        <div className="input-label-title">
            {props.labelName && props.labelName !== "" ? (<>
                <label className="input-label" htmlFor={props.htmlFor}>
                    {props.labelName}
                    {props.labelName.length > 0 && props.isRequired && <span className="validation-star">*</span>}
                    {isLabelIconVisible &&
                        <Iconify className={`ml-2`}
                            style={fieldSetting?.labelConfig?.iconStyle}
                            icon={fieldSetting?.labelConfig?.icon} />
                    }
                </label>
            </>
            ) : null}

        </div>
    );
};
Label.propTypes = {
    htmlFor: PropTypes.string,
    isRequired: PropTypes.bool,
    labelName: PropTypes.string,
    fieldSetting: PropTypes.shape({
        isLabelIconVisible: PropTypes.bool,
        icon: PropTypes.string,
        iconStyle: PropTypes.object,
    }),
};
export default Label;